const payment = {
  proceedPayment: "Zur Zahlung fortfahren",
  retryPayment: "Zahlung erneut durchführen",
  paymentErrorTitle: "Zahlung fehlgeschlagen",
  paymentErrorContent:
    "Stellen Sie sicher, dass Sie die richtigen Informationen eingegeben haben. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an den Administrator.",
  paymentSuccessTitle: "Zahlung erfolgreich!",
  paymentSuccessContent:
    "Ihre Zahlung wurde bestätigt. Ihr Abonnement ist nun aktiv.",
};

export default payment;
